/* Copyright (c) 2020 Business News Americas Limitada - All Rights Reserved Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential */
import React, {Component, Suspense} from 'react';
import {Navbar, Nav} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import ErrorBoundary from '../errorBoundary.js';
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";

/* * Navbar component. The page navbar */
class NavBar extends Component {
  /*
  * Constructor for NavBar class
  * @param props   is used to pass data from a component to another
  */
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }

  /*
  * Registry errors info
  * @param error     the error code
  * @param errorInfo the error info
  */
  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({error: error, errorInfo: errorInfo})
    // You can also log error messages to an error reporting service here
  }

  /*
  * Change language page
  * @param lang  the language to change
  */
  changeLanguage(lang) {
    this.props.i18n.changeLanguage(lang);
  }

  /*
    * Render the element
    */
  render() {
    const {t} = this.props;
    let lang = this.props.i18n.language;
    lang = lang.replace(/\-.*/,'');
    return (
    <ErrorBoundary>
      <Navbar variant="light" className="justify-content-end">
        <Nav>
          <Nav.Link qa-automation="link_robot_go_to_bna" className="text-dark" href="https://www.bnamericas.com">{t('goToBNa')}</Nav.Link>
          <DropdownButton
              qa-automation="cmd_robot_change_lang"
              onSelect={(evt) => {
                this.changeLanguage(evt)
              }}
              id="dropdown-basic-button"
              drop="down"
              className="dropdown-language-list"
              title={lang}>
                <Dropdown.Item qa-automation={"select_robot_language_en"}
                               eventKey={'en'} className={lang === 'en' ? 'font-weight-bold' : ''}>
                  {t('languageEn')}
                </Dropdown.Item>
                <Dropdown.Item qa-automation={"select_robot_language_es"}
                               eventKey={'es'} className={lang === 'es' ? 'font-weight-bold' : ''}>
                    {t('languageEs')}
                </Dropdown.Item>
                <Dropdown.Item qa-automation={"select_robot_language_pt"}
                               eventKey={'pt'} className={lang === 'pt' ? 'font-weight-bold' : ''} >
                  {t('languagePt')}
                </Dropdown.Item>
          </DropdownButton>
        </Nav>
      </Navbar>
    </ErrorBoundary>);
  }
}
const MyComponent = withTranslation()(NavBar)

// i18n translations might still be loaded by the xhr backend
// use react's Suspense
export default function App() {
  return (<Suspense fallback="">
    <MyComponent/>
  </Suspense>);
}
